if (!customElements.get('stats-list')) {
  customElements.define('stats-list', class StatsList extends HTMLElement {
    constructor() {
      super()
    }

    countUp(trigger, counter) {
      const number = Number(counter.dataset.number)
      let current = 0

      const count = (increasement = 1) => {
        if (current <= number) {
          current = Math.min(number, current + increasement)
        }

        counter.textContent = current.toLocaleString('en-US')
      }

      const observer = new IntersectionObserver((el) => {
        if (el[0].isIntersecting) {
          const interval = setInterval(() => {
            if (current < number) {
              count(Math.max(1, Math.ceil(number / 100)))
            } else {
              clearInterval(interval)
            }
          }, 20)
        }
      }, { threshold: [0] })

      observer.observe(trigger)
    }

    connectedCallback() {
      this.querySelectorAll('.js-stats-item').forEach((item) => {
        this.countUp(item, item.querySelector('.js-stats-item-number'))
      })
    }
  });
}